/**
 * User Roles
 * Defines the available roles in the application.
 */
export const ROLES = {
  ADMIN: 'admin',
  CONTENT_CREATOR: 'content_creator',
};

export default ROLES;
